import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traducciones
const resources = {
  es: {
    translation: {
      // Navigation
      nav: {
        home: 'Inicio',
        dashboard: 'Dashboard',
        login: 'Ingresar',
        register: 'Registrarse',
        logout: 'Cerrar Sesión',
        profile: 'Perfil',
        admin: 'Admin'
      },
      // Landing Page
      landing: {
        hero_title: 'Tu Puerta al Universo Viubux',
        hero_subtitle: 'Regístrate para acceder a todo el contenido en Viubux Reader y Viubux Play: audiolibros, podcasts, ebooks, películas y más.',
        hero_tagline: '"Conectamos Mentes Brillantes"',
        cta_start: 'Comenzar Ahora',
        cta_learn: 'Saber más',
        commission: 'Comisión'
      },
      // Auth
      auth: {
        login_title: 'Iniciar Sesión',
        register_title: 'Crear Cuenta',
        email: 'Correo electrónico',
        password: 'Contraseña',
        confirm_password: 'Confirmar contraseña',
        full_name: 'Nombre completo',
        phone: 'Teléfono',
        login_btn: 'Iniciar Sesión',
        register_btn: 'Registrarse',
        no_account: '¿No tienes cuenta?',
        have_account: '¿Ya tienes cuenta?',
        forgot_password: '¿Olvidaste tu contraseña?'
      },
      // Dashboard
      dashboard: {
        welcome: 'Bienvenido',
        my_network: 'Mi Red',
        commissions: 'Comisiones',
        payments: 'Pagos',
        settings: 'Configuración',
        subscription: 'Suscripción',
        pro_marketing: 'Pro-Marketing',
        referral_link: 'Enlace de Referido',
        copy_link: 'Copiar Enlace',
        link_copied: '¡Enlace copiado!',
        available_balance: 'Saldo Disponible',
        pending_balance: 'Saldo Pendiente',
        total_earned: 'Total Ganado',
        direct_referrals: 'Referidos Directos',
        active_referrals: 'Referidos Activos',
        network_size: 'Tamaño de Red'
      },
      // Subscription
      subscription: {
        title: 'Suscripción',
        monthly: 'Mensual',
        annual: 'Anual',
        enrollment: 'Inscripción de Autor',
        per_month: '/mes',
        per_year: '/año',
        one_time: 'pago único',
        renew: 'Renovar Suscripción',
        view_plans: 'Ver Planes de Pago',
        best_value: 'Mejor valor',
        save: 'Ahorra',
        features: {
          unlimited_access: 'Acceso ilimitado a audiolibros',
          new_titles: 'Nuevos títulos cada semana',
          any_device: 'Escucha en cualquier dispositivo',
          annual_discount: '20% de descuento incluido',
          one_payment: 'Un solo pago, sin preocupaciones'
        }
      },
      // Payment
      payment: {
        select_plan: 'Selecciona tu plan',
        select_method: 'Método de pago',
        total: 'Total a pagar',
        processing: 'Procesando...',
        pay_now: 'Pagar Ahora',
        card: 'Tarjeta de crédito/débito',
        bank_transfer: 'Transferencia bancaria',
        prices_in: 'Precios en',
        mexico: 'Pesos Mexicanos',
        spain: 'Euros',
        international: 'Dólares Americanos'
      },
      // Profile
      profile: {
        title: 'Mi Perfil',
        edit: 'Editar Perfil',
        save: 'Guardar Cambios',
        cancel: 'Cancelar',
        personal_info: 'Información Personal',
        contact_info: 'Información de Contacto',
        social_networks: 'Redes Sociales',
        my_link: 'Mi Enlace Único'
      },
      // Common
      common: {
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        save: 'Guardar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Eliminar',
        confirm: 'Confirmar',
        back: 'Volver',
        next: 'Siguiente',
        previous: 'Anterior',
        search: 'Buscar',
        filter: 'Filtrar',
        all: 'Todos',
        active: 'Activo',
        inactive: 'Inactivo',
        pending: 'Pendiente',
        completed: 'Completado',
        yes: 'Sí',
        no: 'No'
      },
      // Footer
      footer: {
        rights: 'Todos los derechos reservados',
        privacy: 'Política de Privacidad',
        terms: 'Términos y Condiciones',
        contact: 'Contacto'
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        dashboard: 'Dashboard',
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
        profile: 'Profile',
        admin: 'Admin'
      },
      // Landing Page
      landing: {
        hero_title: 'Affiliate Program',
        hero_subtitle: 'Join the audiobook revolution. Earn recurring commissions while sharing quality content from the Series and ViubuxConnect Editorial.',
        hero_tagline: '"Connecting Brilliant Minds"',
        cta_start: 'Get Started',
        cta_learn: 'Learn More',
        commission: 'Commission'
      },
      // Auth
      auth: {
        login_title: 'Login',
        register_title: 'Create Account',
        email: 'Email',
        password: 'Password',
        confirm_password: 'Confirm password',
        full_name: 'Full name',
        phone: 'Phone',
        login_btn: 'Login',
        register_btn: 'Register',
        no_account: "Don't have an account?",
        have_account: 'Already have an account?',
        forgot_password: 'Forgot your password?'
      },
      // Dashboard
      dashboard: {
        welcome: 'Welcome',
        my_network: 'My Network',
        commissions: 'Commissions',
        payments: 'Payments',
        settings: 'Settings',
        subscription: 'Subscription',
        pro_marketing: 'Pro-Marketing',
        referral_link: 'Referral Link',
        copy_link: 'Copy Link',
        link_copied: 'Link copied!',
        available_balance: 'Available Balance',
        pending_balance: 'Pending Balance',
        total_earned: 'Total Earned',
        direct_referrals: 'Direct Referrals',
        active_referrals: 'Active Referrals',
        network_size: 'Network Size'
      },
      // Subscription
      subscription: {
        title: 'Subscription',
        monthly: 'Monthly',
        annual: 'Annual',
        enrollment: 'Author Enrollment',
        per_month: '/month',
        per_year: '/year',
        one_time: 'one-time payment',
        renew: 'Renew Subscription',
        view_plans: 'View Payment Plans',
        best_value: 'Best value',
        save: 'Save',
        features: {
          unlimited_access: 'Unlimited access to audiobooks',
          new_titles: 'New titles every week',
          any_device: 'Listen on any device',
          annual_discount: '20% discount included',
          one_payment: 'One payment, no worries'
        }
      },
      // Payment
      payment: {
        select_plan: 'Select your plan',
        select_method: 'Payment method',
        total: 'Total to pay',
        processing: 'Processing...',
        pay_now: 'Pay Now',
        card: 'Credit/Debit card',
        bank_transfer: 'Bank transfer',
        prices_in: 'Prices in',
        mexico: 'Mexican Pesos',
        spain: 'Euros',
        international: 'US Dollars'
      },
      // Profile
      profile: {
        title: 'My Profile',
        edit: 'Edit Profile',
        save: 'Save Changes',
        cancel: 'Cancel',
        personal_info: 'Personal Information',
        contact_info: 'Contact Information',
        social_networks: 'Social Networks',
        my_link: 'My Unique Link'
      },
      // Common
      common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        search: 'Search',
        filter: 'Filter',
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        completed: 'Completed',
        yes: 'Yes',
        no: 'No'
      },
      // Footer
      footer: {
        rights: 'All rights reserved',
        privacy: 'Privacy Policy',
        terms: 'Terms and Conditions',
        contact: 'Contact'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
